/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentBooking/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AppointmentBookingStateTextWithIcon from 'DesignSystem/AppointmentBookingStateTextWithIcon/index'
import Assistant from './Assistant/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Provider from './Provider/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentBooking({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/InfoDialog/Content/Content/AppointmentBooking"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let infoDialogAppointmentBookingAppointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'info_dialog',
path: 'appointment_booking.appointment.type.display_color_id',
format: fromHelpers.getAppointmentTypeColor,
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let infoDialogAppointmentBookingAppointmentTypeDisplayNameValueData = fromData.useDataFormat({ viewPath,
context: 'info_dialog',
path: 'appointment_booking.appointment.type.display_name',
format: fromHelpers.formatAppointmentTypeName,
})
let infoDialogAppointmentBookingValueData = fromData.useDataFormat({ viewPath,
context: 'info_dialog',
path: 'appointment_booking',
format: fromHelpers.getAppointmentBookingTime,
})
let infoDialogAppointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'info_dialog',
path: 'appointment_booking.state',
})
let infoDialogAppointmentBookingConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'info_dialog',
path: 'appointment_booking.confirmation_status',
})
  return (<React.Fragment
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="AppointmentBooking.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-27znKR': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-4-27znKR': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-5-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mr-6-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-7-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-8-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-9-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentBooking.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Appointment"
 color={dtColorsNeutral400}
 weight="medium"
 size="normal"
/>
<div
  data-testid="AppointmentBooking.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-9-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="AppointmentBooking.Horizontal:2"
  data-view-path={viewPath}
 style={{'--w-10-27znKR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--h-11-27znKR': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bc-12-27znKR': infoDialogAppointmentBookingAppointmentTypeDisplayColorIdValueData}}
 className={`views-block ${styles.Horizontal2}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="info_dialog.appointment_booking.appointment.type.display_name"
 format="helpers.js formatAppointmentTypeName"
 text={infoDialogAppointmentBookingAppointmentTypeDisplayNameValueData}
 size="small"
/>
</div>
</div>
<div
  data-testid="AppointmentBooking.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-9-27znKR': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="info_dialog.appointment_booking"
 format="helpers.js getAppointmentBookingTime"
 text={infoDialogAppointmentBookingValueData}
/>
<AppointmentBookingStateTextWithIcon
  viewPath={`${viewPath}/AppointmentBookingStateTextWithIcon`}
 data="info_dialog.appointment_booking.state"
 state={infoDialogAppointmentBookingStateValueData}
 data="info_dialog.appointment_booking.confirmation_status"
 confirmation_status={infoDialogAppointmentBookingConfirmationStatusValueData}
 show_icon={true}
 size="tiny"
/>
</div>
<div
  data-testid="AppointmentBooking.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-9-27znKR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<Provider
  viewPath={`${viewPath}/Provider`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="-"
/>
<Assistant
  viewPath={`${viewPath}/Assistant`}
/>
</div>
</div>
{children}
</React.Fragment>)
}